import { useMemo } from 'react'
import { observer } from 'mobx-react-lite'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { AddOnCard } from 'pages/settings/ui/AddOnCard/AddOnCard'
import { PhoneCheckrStore } from './store/phoneCheckrStore'

type IPhoneCheckrProps = {
  store?: PhoneCheckrStore
}

export const PhoneCheckr = observer(({ store }: IPhoneCheckrProps) => {
  const entities = useEntitiesContext()
  const phoneCheckrStore = useMemo(() => store ?? new PhoneCheckrStore(entities), [store, entities])
  return (
    <AddOnCard
      icon='usersCheck'
      iconFontSize={24}
      title='PhoneCheckr'
      price='$0.01 / lookup'
      description={"Improve deliverability by validating contact's numbers."}
      isActive={phoneCheckrStore.isActive}
      onSwitchChange={phoneCheckrStore.handleSwitchChange}
      onSeeDetailsClick={phoneCheckrStore.openFirstModal}
    />
  )
})
